export const updatePasswordStyles = {

}
